/* eslint-disable no-unused-vars */
import React from "react";

// eslint-disable-next-line react/prop-types
function Member({ width = 18, height = 18 }) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={width}
      height={height}
      viewBox="0 0 20 20"
    >
      <path
        id="badge_FILL0_wght400_GRAD0_opsz24"
        d="M4,22a1.925,1.925,0,0,1-1.412-.587A1.927,1.927,0,0,1,2,20V9a1.927,1.927,0,0,1,.588-1.413A1.925,1.925,0,0,1,4,7H9V4a1.927,1.927,0,0,1,.588-1.413A1.925,1.925,0,0,1,11,2h2a1.928,1.928,0,0,1,1.413.587A1.928,1.928,0,0,1,15,4V7h5a2,2,0,0,1,2,2V20a2,2,0,0,1-2,2Zm0-2H20V9H15a2.006,2.006,0,0,1-2,2H11A2.008,2.008,0,0,1,9,9H4Zm2-2h6v-.45a1.409,1.409,0,0,0-.238-.788A1.568,1.568,0,0,0,11.1,16.2a5.138,5.138,0,0,0-1.012-.337,5.29,5.29,0,0,0-2.175,0A5.132,5.132,0,0,0,6.9,16.2a1.568,1.568,0,0,0-.662.562A1.409,1.409,0,0,0,6,17.55Zm8-1.5h4V15H14ZM9,15a1.5,1.5,0,1,0-1.062-.438A1.444,1.444,0,0,0,9,15Zm5-1.5h4V12H14ZM11,9h2V4H11ZM12,14.5Z"
        transform="translate(-2 -2)"
        fill="#8C8C8C"
      />
    </svg>
  );
}

export default Member;
